import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  {
    projectResource,
    nextProjectResource,
  }: Boundaries["disableProjectResource"]["request"],
): State {
  const index = state.findIndex(
    (res) => res.projectResource.uuid === projectResource.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { projectResource, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { projectResource, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  projectResource: Boundaries["disableProjectResource"]["success"],
): State {
  return state.map((res) =>
    res.projectResource.uuid === projectResource.uuid
      ? { projectResource, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  { projectResource }: Boundaries["disableProjectResource"]["failure"],
): State {
  return state.map((res) =>
    res.projectResource.uuid === projectResource.uuid
      ? { projectResource, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.disableProjectResourceRequested]: handleRequest,
    [events.disableProjectResourceSucceeded]: handleSuccess,
    [events.disableProjectResourceFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
